// src/mocks/data/tokenTimers.ts

const ONE_MINUTE = 60_000; // 1 minute in milliseconds
export const ACCESS_TIME = 30 * ONE_MINUTE; // 30 minutes in milliseconds
export const REFRESH_TIME = 24 * 60 * ONE_MINUTE; // 1 day in milliseconds

export let accessTokenExpiry = Date.now() + ACCESS_TIME;
export let refreshTokenExpiry = Date.now() + REFRESH_TIME;

/* eslint-disable no-console */

console.log(
  `Access token expiry set to: ${new Date(accessTokenExpiry).toISOString()}`,
);
console.log(
  `Refresh token expiry set to: ${new Date(refreshTokenExpiry).toISOString()}`,
);

export const resetAccessTokenExpiry = () => {
  accessTokenExpiry = Date.now() + ACCESS_TIME;
  console.log(
    `Access token expiry set to: ${new Date(accessTokenExpiry).toISOString()}`,
  );
  console.log(
    `Refresh token expiry set to: ${new Date(refreshTokenExpiry).toISOString()}`,
  );
};
export const resetTokenTimers = () => {
  accessTokenExpiry = Date.now() + ACCESS_TIME;
  refreshTokenExpiry = Date.now() + REFRESH_TIME;
  console.log(
    `Access token expiry set to: ${new Date(accessTokenExpiry).toISOString()}`,
  );
  console.log(
    `Refresh token expiry set to: ${new Date(refreshTokenExpiry).toISOString()}`,
  );
};
